import React from "react";

const EventSchedulerResource = () => {
  return <div className={"pl-2 center flex text-sm"}>Events</div>;
};

EventSchedulerResource.propTypes = {};

export default EventSchedulerResource;
